import React, { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import { FaTriangleExclamation } from "react-icons/fa6";
import { navigateHook } from "../../../../../hooks/use-navigate.js";

const ReportContent = ({ data, showGarrison, tableColumns }) => {
    const navigate = navigateHook();

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, "Controle de km", "vehicle-km-data",);
    }, [data, tableColumns]);

    if (!data?.length) return null;

    const warning = (value) => value ? (
        <span className="flex justify-center" title="Km inconsistente">
            <FaTriangleExclamation/>
        </span>
    ) : null;

    const columns = [
        {
            id: "vehicle",
            className: "w-[22%] text-left",
            render: (item) => (
                <a onClick={() => navigate(`/vehicles/form/${item.id}`, true)} className="report-link">
                    {[item.prefix, item.plate, item.type].filter(Boolean).join(" | ")}
                </a>
            ),
        },
        {
            id: "garrisons",
            className: "w-[10%]",
            render: (item) => item.garrison_total,
        },
        {
            id: "totalMileage",
            className: "w-[10%]",
            render: (item) => (item.hasInconsistence ? warning(true) : item.km_total),
        },
        {
            id: "garrisonMileage",
            className: "w-[17%]",
            render: (item) =>
                item.hasInconsistence ? warning(true) : item.km_garrison,
        },
        {
            id: "deviationMileage",
            className: "w-[17%]",
            render: (item) =>
                item.hasInconsistence ? warning(true) : item.km_garrison_deviation,
        },
        {
            id: "inconsistent",
            className: "w-[24%]",
            render: (item) => item.km_inconsistent,
        },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="vehicle-km-data" className="report-table table" sheet-name="Controle de km">
                    <thead className="thead-background">
                        <tr className="text-center">
                            {visibleColumns.map((column) => (
                                <th key={column.id} className={column.className}>
                                    {tableColumns[column.id].label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item) => (
                            <React.Fragment key={item.id}>
                                <tr className={`text-center ${showGarrison ? "details-row" : ""}`}>
                                    {visibleColumns.map((column) => (
                                        <td key={column.id} className={column.className}>
                                            {column.render(item)}
                                        </td>
                                    ))}
                                </tr>

                                {showGarrison && item.garrison?.length > 0 && (
                                    <tr>
                                        <td colSpan={visibleColumns.length}>
                                            <table className="table max-w-[95%] mx-auto">
                                                <thead className="thead-background">
                                                <tr className="!bg-[#f6f6f6] text-center">
                                                    <th className="w-[28%] !font-normal">Guarnição</th>
                                                    <th className="w-[12%] !font-normal">D/H Inicial</th>
                                                    <th className="w-[12%] !font-normal">D/H Final</th>
                                                    <th className="w-[10%] !font-normal">Km Inicial</th>
                                                    <th className="w-[10%] !font-normal">Km Final</th>
                                                    <th className="w-[10%] !font-normal">Km Total</th>
                                                    <th className="w-[28%] !font-normal">Inconsistência</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {item.garrison.map((garrison, index) => (
                                                    <tr key={index} className="text-center">
                                                        <td>
                                                            <a onClick={() => navigate(`/despacho/garrison/form/${garrison.garrison_id}`, true,)} className="report-link">
                                                                {garrison.garrison_name}
                                                            </a>
                                                        </td>
                                                        <td>{garrison.garrison_start}</td>
                                                        <td>{garrison.garrison_end}</td>
                                                        <td>{garrison.compositiongarrison_initialmileage}</td>
                                                        <td>{garrison.compositiongarrison_finalmileage}</td>
                                                        <td>{garrison.km_garrison_total}</td>
                                                        <td>{garrison.km_inconsistent}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            ) : (
            <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;